import React from 'react';

const Switch = ({ isOn, handleToggle }) => {
	return (
		<div className="Switch">
			<input
				className="react-switch-checkbox"
				onChange={handleToggle}
				id={`react-switch-new`}
				type="checkbox"
			/>
			<label
				style={{ background: isOn && '#48CD60' }}
				className="react-switch-label"
				htmlFor={`react-switch-new`}
			>
				<span className={`react-switch-button`} />
			</label>
		</div>
	);
};

export default Switch;
